import { Menu, MenuDivider, MenuItem, Position } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomPopover from "components/Atoms/CustomPopover"
import Links from "constants/links"
import { useSearchFilter } from "hooks/searchFilterHooks"
import useLink from "hooks/useLink"
import React from "react"

const DispatchActions = ({ schedules }) => {
  const [{ date }] = useSearchFilter()
  const redirect = useLink()
  return (
    <CustomPopover
      position={Position.BOTTOM_LEFT}
      minimal={true}
      popoverClassName="vt-row-operation-popover"
      className="vt-row-operation-popover"
      content={
        <Menu>
          <MenuDivider title="Schedules" />
          <MenuItem
            icon="document-share"
            text="Gate Pass"
            onClick={() =>
              redirect(Links.GATE_PASS, { date, schedule: schedules })
            }
          />
        </Menu>
      }
    >
      <CustomButton icon="more" minimal={true} />
    </CustomPopover>
  )
}

export default DispatchActions
